import cx from 'classnames';

import styles from './HandshakePhoto.module.scss';

export const HandshakePhoto = ({ className, url }: { className?: string; url: string }) => (
  <div className={cx(styles.component, className)}>
    <div>
      <img src={url} />
    </div>
  </div>
);
